<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati {{$route.query.title}}</h1>
    
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <div class="columnBar">
        Skriti stolpci:
              <kendo-multiselect 
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>
        
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                     
                        :pageable="pageable"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                 
                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.veljaven"/>
                    </template>
                    <template v-slot:kategorijaCell="{props}">
                      <listCell :list="props.dataItem.stranka.sheme.kategorije.map(i=>i.id?i.id:i)"
                        :displayname="'kratkinaziv'"
                        hover="naziv"
                        :sifrant="kategorije"
                        sifrantid="id"
                        :data-item="props.dataItem" 
                        dataitemname="kategorije"

                        />
                    </template>
                    <template v-slot:dejavnstiCell="{props}">
                      <listCell :list="props.dataItem.stranka.sheme.dejavnosti"
                                                
                             :displayname="'naziv'"
                              :data-item="props.dataItem" 
                               dataitemname="dejavnosti"
                        />
                    </template>
                    <template v-slot:statusCell="{props}">
                      <td colspan="1"><span>
                        {{ props.dataItem.sheme.find(s=>s.sezona==2022&&s.shema==$route.query.title).status }}
</span></td>
                    </template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                         
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        </div>
                            
                        </toolbar>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import CheckBoxGridItem from './support/CheckBoxGridItem';
import ListCell from './support/ListCell';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';

 


export default {
  props:['sezona','shema'],
   components:{
      'dropdownlist': DropDownList,
      'cbItem': CheckBoxGridItem,
      'listCell': ListCell,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
         
            dataSezona:this.sezona,
          
         
            


            filter: {
                logic: "and",
                filters: [
                    { field: "veljaven", operator: "eq", value: true }
                 
                ]
            },
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
                    kategorije:[],
            sort: [
                { field: 'datumizdaje', dir: 'asc' }
            ],
            
          

           

        }
    },
    created () {

      
            
      
      
    },
    mounted() {
       this.naloziPodatke();
 
 },
    computed: {
         pageable(){
            return { buttonCount: 4, pageSizes: [10,100,this.gridData?.length] }
        },
        columns() {

        let columns=[
       
                { field: "stevilkacertifikata", title:"Številka certifikata",width: "170px"},
                  { field: "datumizdaje", title:"Datum izdaje",width: "100px",filterable:false, type:"date",format:"{0:d}"},
                  { field: "datumveljavnosti", title:"Datum veljavnosti",width: "100px",filterable:false, type:"date",format:"{0:d}"},
                  { field: "veljaven", title:"Veljaven",width: "100px",cell:"cbItem",hidden:true},
                  { field: "stranka.sheme.kontrolnaStevilka", title:"Kontrolna št.",width: "150px"},
                  { field: "stranka.kontakt.naziv", title:"Nosilec",width: "150px"},
                 
                  
                //{ field: "statuspridelovalca", title:"Status",width: "150px"},
                { field: "stranka.kontakt.postnastevilka", title:"Poštna številka"},
                { field: "stranka.kontakt.posta", title:"Pošta"},
                
           
            ];

        if(this.$route.query.title=="EKO PRI")
                columns.splice(6,0, { field: "stranka.kmgmid", title:"KMG-MID",width: "150px"},);
        if(this.$route.query.title=="EKO PRE"){
                columns.splice(6,0, { field: "stranka.mso", title:"MSO",width: "150px"},);
                   columns.splice(7,0, { field: "stranka.davcnastevilka", title:"DŠ",width: "150px"},);
            }

        if(this.$route.query.title=="EKO PRI"||this.$route.query.title=="EKO PRE"){
                
                columns.push({field:"kategorije", title:"Kategorije",cell:"kategorijaCell",});
                columns.push({field:"dejavnosti" ,title:"Dejavnosti",cell:"dejavnstiCell",});
                columns.push({ field: "nosilecddk", title:"Nosilec dopolnile dejavnosti", hidden:true,filter:'boolean',cell:"cbItem"});
                
                //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
              }

                return columns;
    },

         hiddenColumns() {
            return this.columns.filter(c=>c.hidden);
        },
...mapState('users', ['userDetails','sezoneBranje']),
...mapState('sifrant', ['sifrant','dataSezone']),
         ...mapState({gridData(state) {
          return state?.certifikat?.certifikati;
        }}),         
    
           },
      watch: {
        '$route' () {
            this.naloziPodatke()
        },
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
           // sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
             //   sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
          //  sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {

        ...mapActions('certifikat', ['loadVse']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        
        naloziPodatke: function(){
                 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
    var thisApp=this;
            this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}).then(()=>{
                 thisApp.kategorije=thisApp.sifrant["kategorije"];   
                    this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title}).then(()=>{

                        //thisApp.gridData => najdi nosilca kontakt
                        thisApp.gridData.forEach(element => {
                            let p=element.stranka;
                            
                            /*var kontakt=element.stranka.kontakt?.find(k=>k.glavni);
                            if(!kontakt)
                                kontakt=element.stranka.kontakt?.find(k=>k.vloga=='nosilec kmg');
                            if(!kontakt)
                                kontakt=element.stranka.kontakt[0];

                                element.stranka.kontakt=kontakt;
                            */
                        let kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg");
                        if(!kontakt)
                            kontakt=p.kontakt.find(k=>k.glavni);
                        if(!kontakt)
                            kontakt=p.kontakt[0];

                        let nosilecddk=p.kontakt.find(k=>k.vloga=="nosilec dopolnilne dejavnosti na kmg");
                        Vue.set(p,"nosilecddk",false)
                        if(nosilecddk) {
                            Vue.set(p,"nosilecddk",true)
                            kontakt.naziv=nosilecddk.naziv;
                        }
                        p.kontakt=kontakt;
                        });
                     

                    })

                });

        },
skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
           
        },

        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število:']);
        },
        nogaSteviloCertifikatova: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.length,"n0")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
        sezonaChange(event) {
          //  this.$router.push({ path: this.$route.path, query: { sezona:sezona.sezona,title:this.$route.query.title} })
            
            //this.naloziPodatke(this.$route.query.title)//{
            //this.loadShema({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


            const sezona = event.value;
            this.dataSezona=sezona;
            console.log("params");
            console.log({ sezona:sezona.sezona,shema:this.$route.query.title});

            this.$router.push({ name: 'certifikati', params: { sezona:sezona.sezona,shema:this.$route.query.title},query:{title:this.$route.query.title} })
            this.dataSezona=sezona;
            //(this.loadVse(this.dataSezona);



        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            //tukaj je treba imet nov stolpec, s številkami in sortirat po njem...
            console.log(this.sort);
            this.createAppState(event.data);

            if(this.sort?.length>0&&this.sort[0]?.field=='stevilkacertifikata'){
                
                let stsort=this.gridData.sort((a,b)=>{
                    try{
                    var numa=parseInt(a.stevilkacertifikata.split("-")[0]);
                    var numb=parseInt(b.stevilkacertifikata.split("-")[0]);
                    if(isNaN(numa))
                        numa=0;
                    if(isNaN(numb))
                        numb=0;

                        console.log(numa)
                    if(this.sort[0].dir!="asc"){
                        return numa-numb;
                    }
                    else{
                        return numb-numa;
                    }
                    }
                    catch(e){
                        console.log(e);
                        console.log(a);
                        console.log(b);
                        }

                });

                this.dataResult = process(stsort, {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                group: this.group
            });                
            }
            else {
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
            }


         
         

        },
      
        exportExcel () {
            this.saveExcel({
                data: this.dataResult.data,
                fileName: this.dataSezona.sezona+"_CERTIFIKATI",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

